import "./Politicas.css";

export default function Envios() {
  return (
    <div className="politicas-container">
      <h1>Política de Envíos</h1>

      <ul>
        <li>Los envíos se realizan únicamente dentro del territorio colombiano.</li>
        <li>Tiempo estimado de entrega: 2 a 5 días hábiles dependiendo de la ubicación.</li>
        <li>Retrasos por transporte, clima o eventos externos no son responsabilidad de la tienda.</li>
        <li>El cliente es responsable de proporcionar la dirección correcta.</li>
        <li>Se puede hacer seguimiento en línea a través del sistema de envíos.</li>
      </ul>
    </div>
  );
}
